import projects from '@/assets/json/projects/projects.json'

import mainnav from '@/components/_globals/mainnav/mainnav.vue'

// swiper plugin
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'index',
  components: {
    swiper,
    swiperSlide,
    mainnav
  },
  data: function () {
    return {
      newId: null,
      dragging: false,
      projectsSwiper: {},
      prevDisabled: false,
      nextDisabled: false,
      minimun: false,
      maximun: false,
      sliderMax: null,
      currentSlide: 1,
      currentSlideSwipe: 1,
      projects,
      image: null,
      currentProject: null,
      swiperOption: {
        // loop: true,
        initialSlide: this.$store.state.projectData.emitted && this.$store.state.projectData.id - 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  watch: {
    currentSlide (newid, oldid) {
      this.newId = newid
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted () {
    const id = this.$store.state.projectData.id
    if (this.$store.state.projectData.emitted) {
      this.currentSlide = id
    }
  },
  methods: {
    decreaseCurrentSlide () {
      this.dragging = false

      if (this.currentSlide === 1) {
        this.currentSlide = this.projects.length
      } else {
        this.currentSlide = this.currentSlide - 1
      }
    },
    increaseCurrentSlide () {
      this.dragging = false

      if (this.currentSlide === this.projects.length) {
        this.currentSlide = 1
      } else {
        this.currentSlide = this.currentSlide + 1
      }
    },
    onSlideChange () {
      this.dragging = true
      const id = this.$refs.mySwiper.swiper.realIndex + 1
      const project = this.projects.map(item => item.main).filter(item => item.id === id)
      this.projectsSwiper = project[0]
      this.currentSlide = id
    }
  },
  created () {
    const maxValue = this.projects.length
    this.sliderMax = maxValue
  }
}



// WEBPACK FOOTER //
// ./src/components/index/index.js